/*项目类型表 和 项目申请相关*/
import {apiRequest} from "@/api/api";

//----------------------------------------------项目类型

/*获取项目列表 -- 申报单位*/
export function getProjectList_Apply(config) {
    config.method = 'get'
    config.url = '/project/Project/getProjectListForApply'
    apiRequest(config)
}

/*获取项目列表 -- 推荐单位*/
export function getProjectList_Recom(config) {
    config.method = 'get'
    config.url = '/project/Project/getProjectListForRecom'
    apiRequest(config)
}

/*通过项目编号获取项目信息*/
export function getPrjInfoByCode(config) {
    config.method = 'get'
    config.url = '/project/Project/getPrjInfoByCode'
    apiRequest(config);
}

/*通过登录账号获取企业基本信息*/
export function getCompanyInfoByLoginUser(config) {
    config.method = 'get'
    config.url = '/project/Company/getInfoByLoginUser'
    apiRequest(config)
}

/*获取某项目的推荐单位*/
export function getRecomCompany(config) {
    config.method = 'get'
    config.url = '/project/Project/getRecdEnp'
    apiRequest(config)
}

//----------------------------------------------项目申请

/* 获取项目的阶段信息 */
export function getPrjStageInfo(config) {
    config.method = 'get'
    config.url = '/zhejiang/PaDeclarationStage/getPrjStageInfo'
    apiRequest(config)
}

/*获取项目的当前阶段*/
export function getPrjCurStage(config) {
    config.method = 'get'
    config.url = '/zhejiang/PaDeclarationStage/getPrjCurStage'
    apiRequest(config)
}

/* 获取登录用户已申报项目数量  */
export function getCountByUserCode(config) {
    config.method = 'get'
    config.url = '/project/ProjectApplication/getCountByUserCode'
    apiRequest(config)
}

/*通过项目申请编号获取项目信息*/
export function getPrjInfoByApplyId(config) {
    config.method = 'get'
    config.url = '/project/ProjectApplication/getPrjInfoByApplyId'
    apiRequest(config);
}

/*申请提交*/
export function applySubmit(config) {
    config.method = 'post'
    config.formData = true
    config.url = '/project/ProjectApplication/applySubmit'
    apiRequest(config)
}

/*项目申请 审核提交*/
export function applyAuditSubmit(config) {
    config.method = 'post'
    config.formData = true;
    config.url = '/project/ProjectApplication/applyAuditSubmit'
    apiRequest(config)
}

/*项目申请 统一推荐*/
export function applyUnifyRecom(config) {
    config.method = 'post'
    config.formData = true;
    config.url = '/project/ProjectApplication/applyUnifyRecom'
    apiRequest(config)
}

/*申请删除*/
export function applyDelete(config) {
    config.method = 'post'
    config.formData = true
    config.url = '/project/ProjectApplication/applyDelete'
    apiRequest(config)
}